// App.jsx or BookPage.jsx
import { useParams } from "react-router-dom";
import BookViewerPWA from "./BookViewerPWA";
import booksConfig from "../general/books";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";

const BookPage = () => {
  const { id } = useParams();
  const config = booksConfig[id];

  if (!config) {
    return (
      <>
        <Navbar />
        <div className="p-6 text-center text-xl text-gray-600">
          📖 புத்தகம் கிடைக்கவில்லை (Book not found)
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <BookViewerPWA config={config} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BookPage;
